import r from 'styled-components';

var t=r.div`
  display: flex;
  gap: var(--spacing-regular);
`,p={ButtonGroup:t};

export { t as a, p as b };
